import { MouseEvent, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Props for a UI-kit `Link` that should navigate inside the app. The kit's Link is a plain
 * `<a href>` (and its types don't take react-router's `to`), so every click reloaded the whole
 * app. A plain left click now navigates in place; modified clicks (new tab/window) keep the href.
 */
const useInAppLink = () => {
  const navigate = useNavigate();
  return useCallback(
    (to: string) => ({
      href: to,
      onClick: (event: MouseEvent<HTMLElement>) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        navigate(to);
      }
    }),
    [navigate]
  );
};

export default useInAppLink;
